// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Faq_container__dBjiK {
  margin: 160px auto 0;
}
.Faq_container__dBjiK .Faq_title__PggrD {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  text-transform: uppercase;
  text-align: center;
  font-family: "DrukWideCyr_medium";
  color: #ffffff;
  margin-bottom: 75px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 {
  margin-bottom: 24px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_question__YAoK0 {
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  padding-bottom: 18px;
  padding-top: 18px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_question__YAoK0 .Faq_arrow__qDBN1 {
  align-items: center;
  background-color: #40204d;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 40px;
  transition: all 0.2s linear;
  min-width: 40px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_question__YAoK0 .Faq_arrow__qDBN1 img {
  width: 24px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_question__YAoK0.Faq_active__J7aq3 {
  border-bottom: unset;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  color: #e0e0e0;
  display: none;
  line-height: 150%;
  padding-bottom: 24px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ {
  display: flex;
  gap: 20px;
  margin-top: 16px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ .Faq_tg__EanlT {
  align-items: center;
  background-color: #19334f;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  width: 64px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ .Faq_tg__EanlT:hover {
  background-color: #244971;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ .Faq_phone__vjSF3 {
  align-items: center;
  background-color: #3a2159;
  border-radius: 8px;
  color: #ae6fff;
  display: flex;
  gap: 8px;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  width: auto;
  padding: 10px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ .Faq_phone__vjSF3:hover {
  background-color: #4a2c6f;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ.Faq_open__Zujvu {
  display: block;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_link__NF0LC {
  color: #ead40c;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_listItem__66R0L {
  display: flex;
  gap: 8px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_listItem__66R0L .Faq_listImg__IpOeK {
  height: 24px;
  width: 8px;
}
.Faq_container__dBjiK .Faq_item__bWLH6 .Faq_listItemBig__zhxwZ {
  align-items: baseline;
}

@media (max-width: 850px) {
  .Faq_container__dBjiK {
    margin-top: 100px;
  }
  .Faq_container__dBjiK .Faq_title__PggrD {
    margin-bottom: 40px;
  }
}
@media (max-width: 500px) {
  .Faq_container__dBjiK {
    margin-top: 100px;
  }
  .Faq_container__dBjiK .Faq_title__PggrD {
    margin-bottom: 40px;
    font-size: 20px;
  }
  .Faq_container__dBjiK .Faq_item__bWLH6 .Faq_question__YAoK0 {
    font-size: 20px;
  }
  .Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ {
    font-size: 16px;
  }
  .Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_paragraph__GK7QR {
    margin-bottom: 8px;
  }
  .Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_listItem__66R0L {
    margin-bottom: 8px;
  }
  .Faq_container__dBjiK .Faq_item__bWLH6 .Faq_answer__ZfMaJ .Faq_help__NgdBZ {
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Faq/Faq.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;AADF;AAGE;ECEA,eAAA;EACA,gBAAA;EACA,kBAAA;EDFE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAEI;ECMF,eAAA;EACA,gBAAA;EACA,kBAAA;EDLI,iDAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AACN;AACM;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;AACR;AACQ;EACE,WAAA;AACV;AAQI;EACE,oBAAA;AANN;AASI;ECZF,eAAA;EACA,gBAAA;EACA,kBAAA;EDaI,iDAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AANN;AAQM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AANR;AAQQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AANV;AAQU;EACE,yBAAA;AANZ;AAUQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;AARV;AAUU;EACE,yBAAA;AARZ;AAcI;EACE,cAAA;AAZN;AAeI;EACE,cAAA;AAbN;AAgBI;EACE,aAAA;EACA,QAAA;AAdN;AAgBM;EACE,YAAA;EACA,UAAA;AAdR;AAkBI;EACE,qBAAA;AAhBN;;AAqBA;EACE;IACE,iBAAA;EAlBF;EAoBE;IACE,mBAAA;EAlBJ;AACF;AAsBA;EACE;IACE,iBAAA;EApBF;EAsBE;IACE,mBAAA;IACA,eAAA;EApBJ;EAwBI;IACE,eAAA;EAtBN;EAyBI;IACE,eAAA;EAvBN;EAyBM;IACE,kBAAA;EAvBR;EA0BM;IACE,kBAAA;EAxBR;EA2BM;IACE,SAAA;EAzBR;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  margin: 160px auto 0;\n\n  .title {\n    @include h2;\n    font-weight: 500;\n    font-size: 40px;\n    text-transform: uppercase;\n    text-align: center;\n    font-family: \"DrukWideCyr_medium\";\n    color: #ffffff;\n    margin-bottom: 75px;\n  }\n\n  .item {\n    margin-bottom: 24px;\n\n    .question {\n      @include subtitle2m;\n\n      border-bottom: 1px solid rgba(220, 220, 220, 0.1);\n      color: #ffffff;\n      cursor: pointer;\n      display: flex;\n      justify-content: space-between;\n      gap: 15px;\n      padding-bottom: 18px;\n      padding-top: 18px;\n\n      .arrow {\n        align-items: center;\n        background-color: #40204d;\n        border-radius: 8px;\n        display: flex;\n        justify-content: center;\n        height: 40px;\n        transition: all 0.2s linear;\n        min-width: 40px;\n\n        img {\n          width: 24px;\n        }\n\n        // &:hover {\n        //   background-color: #494711;\n        // }\n      }\n    }\n\n    .question.active {\n      border-bottom: unset;\n    }\n\n    .answer {\n      @include subtitle5;\n\n      border-bottom: 1px solid rgba(220, 220, 220, 0.1);\n      color: #e0e0e0;\n      display: none;\n      line-height: 150%;\n      padding-bottom: 24px;\n\n      .help {\n        display: flex;\n        gap: 20px;\n        margin-top: 16px;\n\n        .tg {\n          align-items: center;\n          background-color: #19334f;\n          border-radius: 8px;\n          display: flex;\n          justify-content: center;\n          height: 56px;\n          transition: all 0.2s linear;\n          width: 64px;\n\n          &:hover {\n            background-color: #244971;\n          }\n        }\n\n        .phone {\n          align-items: center;\n          background-color: #3a2159;\n          border-radius: 8px;\n          color: #ae6fff;\n          display: flex;\n          gap: 8px;\n          justify-content: center;\n          height: 56px;\n          transition: all 0.2s linear;\n          width: auto;\n          padding: 10px;\n\n          &:hover {\n            background-color: #4a2c6f;\n          }\n        }\n      }\n    }\n\n    .answer.open {\n      display: block;\n    }\n\n    .link {\n      color: #ead40c;\n    }\n\n    .listItem {\n      display: flex;\n      gap: 8px;\n\n      .listImg {\n        height: 24px;\n        width: 8px;\n      }\n    }\n\n    .listItemBig {\n      align-items: baseline;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    margin-top: 100px;\n\n    .title {\n      margin-bottom: 40px;\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n    margin-top: 100px;\n\n    .title {\n      margin-bottom: 40px;\n      font-size: 20px;\n    }\n\n    .item {\n      .question {\n        font-size: 20px;\n      }\n\n      .answer {\n        font-size: 16px;\n\n        .paragraph {\n          margin-bottom: 8px;\n        }\n\n        .listItem {\n          margin-bottom: 8px;\n        }\n\n        .help {\n          gap: 16px;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Faq_container__dBjiK`,
	"title": `Faq_title__PggrD`,
	"item": `Faq_item__bWLH6`,
	"question": `Faq_question__YAoK0`,
	"arrow": `Faq_arrow__qDBN1`,
	"active": `Faq_active__J7aq3`,
	"answer": `Faq_answer__ZfMaJ`,
	"help": `Faq_help__NgdBZ`,
	"tg": `Faq_tg__EanlT`,
	"phone": `Faq_phone__vjSF3`,
	"open": `Faq_open__Zujvu`,
	"link": `Faq_link__NF0LC`,
	"listItem": `Faq_listItem__66R0L`,
	"listImg": `Faq_listImg__IpOeK`,
	"listItemBig": `Faq_listItemBig__zhxwZ`,
	"paragraph": `Faq_paragraph__GK7QR`
};
export default ___CSS_LOADER_EXPORT___;
